import { api } from "./dataService";

/**
 * Ordnet ein bestehendes Objekt einem anderen Vertrag zu (ACC-321, Korrektur einer
 * Fehlzuordnung). Zieht Objektspartes und verknüpfte Schäden konsistent mit.
 * dryRun: true (Default im Backend) liefert nur eine Vorschau (Ziel-Kunde/-Vertrag,
 * Anzahl betroffener Sparten/Schäden) ohne DB-Änderung; dryRun: false führt die
 * Zuordnung tatsächlich aus.
 *
 * @param {number|string} objektId
 * @param {number|string} vertragId
 * @param {{dryRun: boolean}} options
 * @returns {Promise<{objekt_id: number, from_vertrag_id: number, to_vertrag_id: number, to_vertragsnummer: string, to_kunde_name: string, sparten_count: number, schaden_count: number, applied: boolean}>}
 */
export const moveObjekt = async (objektId, vertragId, { dryRun }) => {
  const response = await api.post(`data/objekts/${objektId}/move`, {
    vertrag_id: vertragId,
    dry_run: dryRun,
  });

  return response.data.data;
};
